import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../Loader';
import { Success } from '../Success';
import { selectFairPlayErrorCode, selectFairPlayStatus } from '../../../../../../../../../selectors/fairPlay';
import { DeclineError } from '../DeclineError';
import { TDispatch } from '../../../../../../../../../../common/types/dispatch';
import { Initial } from '../Initial';
import { FatalError } from '../FatalError';
import { getServiceName } from '../../../../../../../../../utils/publishTerms';
import { EFairPlayErrorCode, EFairPlayStatus } from '../../../../../../../../../types/reducers/fairPlay';
import { joinFairPlayInit } from '../../../../../../../../../actions/fairPlay';
import { generateErrorBannerShowAction } from '../../../../../../../../../actions/webview';
import { AppContext } from '../../../../../../../../../../AppModulesWrapper';
import { selectActiveServiceId } from '../../../../../../../../../reducers/v2/promotion/selectors';

export const OnlyForFairPlayersContainer = () => {
  const { webview } = React.useContext(AppContext);
  const status = useSelector(selectFairPlayStatus);
  const errorCode = useSelector(selectFairPlayErrorCode);
  const serviceId = useSelector(selectActiveServiceId);

  const dispatch = useDispatch<TDispatch>();

  const serviceName = serviceId ? getServiceName(serviceId) : '';

  const joinFairPlay = React.useCallback(() => {
    dispatch(joinFairPlayInit());
  }, [dispatch]);

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('only-in-action-unavailable-reason-banner-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  switch (status) {
    case EFairPlayStatus.initial:
      return <Initial serviceName={serviceName} onClickAccept={joinFairPlay} />;

    case EFairPlayStatus.pending:
      return <Loader />;

    case EFairPlayStatus.success:
      return <Success />;

    case EFairPlayStatus.fail:
      if (errorCode === EFairPlayErrorCode.requestDeclined) {
        return <DeclineError />;
      }

      return <FatalError onClickRetry={joinFairPlay} />;

    default:
      return null;
  }
};
